import axios from '@utils/axios';
import router from '@router/router';

const editConsultingRoom = {
  state: {
    consultingRoomId: 0,
    name: '',
    enabled: false,
    doctor: 0
  },
  mutations: {
    setName(state, name) {
      state.name = name;
    },
    setEnabled(state, enabled) {
      state.enabled = enabled;
    },
    setDoctor(state, doctor) {
      state.doctor = doctor;
    },
    setConsultingRoomId(state, id) {
      state.consultingRoomId = id;
    }
  },
  actions: {
    fetchConsultingRoom(context) {
      return axios.get(`admin/consultingrooms/${context.state.consultingRoomId}`)
        .then((res) => {
          context.commit('setName', res.data.result.name);
          context.commit('setEnabled', res.data.result.isEnabled);
          context.commit('setDoctor', res.data.result.doctorId);
        }).catch(() => {
          router.push({ name: 'admin.dashboard' });
        });
    },
    editConsultingRoom(context) {
      return axios.post('admin/consultingrooms', {
        Id: Number(context.state.consultingRoomId),
        Name: context.state.name,
        IsEnabled: context.state.enabled,
        DoctorId: Number(context.state.doctor)
      });
    },
    resetContext(context) {
      context.commit('setName', '');
      context.commit('setEnabled', false);
      context.commit('setDoctor', 0);
      context.commit('setConsultingRoomId', 0);
    },
  },
  namespaced: true
};

export default editConsultingRoom;
